const reports = {
  "admin.performance-report.download": "Download Report",
}

export const admin = {
  ...reports
}
